import { UserCheckIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';

import { EmployeeCard } from './employee-card';
import type { Employee } from './types';

interface Props {
  employees: Employee[];
  onSelect: (employeeId: string) => void;
}

export function EmployeesGrid({ employees, onSelect }: Props) {
  const { t } = useLanguage();

  if (employees.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-center border rounded-xl bg-card">
        <UserCheckIcon className="w-10 h-10 text-muted-foreground/40" />
        <p className="font-medium text-sm">{t.noEmployeesFound}</p>
        <p className="text-xs text-muted-foreground">{t.noEmployeesDescription}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {employees.map((employee, index) => (
        <EmployeeCard
          key={employee.id}
          employee={employee}
          index={index}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
